export var IconSize;
(function (IconSize) {
    IconSize["small"] = "20px";
    IconSize["medium"] = "28px";
    IconSize["large"] = "36px";
})(IconSize || (IconSize = {}));
export var IconSpacing;
(function (IconSpacing) {
    IconSpacing["small"] = "22px";
    IconSpacing["medium"] = "26px";
    IconSpacing["large"] = "35px";
})(IconSpacing || (IconSpacing = {}));
//# sourceMappingURL=types.js.map